const prefix = 'heaven_knip_';

const keys = {
  ageVerified: `${prefix}ageVerified`,
  deviceId: `${prefix}deviceId`,
};

const StorageUtil = {
  set: (key: string, val: string) => localStorage.setItem(key, val),
  get: (key: string) => localStorage.getItem(key) as string,
  clear: (key: string) => localStorage.removeItem(key),
};

export const storage = {
  ageVerified: {
    isVerified: () => StorageUtil.get(keys.ageVerified) === 'ok',
    setVerified: () => StorageUtil.set(keys.ageVerified, 'ok'),
    clear: () => StorageUtil.clear(keys.ageVerified),
  },
  deviceId: {
    get: (): string => {
      const existing = StorageUtil.get(keys.deviceId);
      if (existing) return existing;
      const id = crypto.randomUUID();
      StorageUtil.set(keys.deviceId, id);
      return id;
    },
  },
};
